import fileDownload from 'js-file-download';
import { Request } from '..';

export const run = async ({
  repository_name,
  custom_fields,
  processUid,
  quantity,
  subProcessUid,
  group,
}: ExecutionsType.ExecutionsParamsAPI): Promise<ExecutionsType.ExecutionsResponseAPI | null> => {
  try {
    const { data } = await Request.post('/executions', {
      repository_name,
      process_name: processUid,
      sub_process_name: subProcessUid,
      qtd_massa: quantity,
      custom_fields,
      group,
    });

    return data;
  } catch (error) {
    return null;
  }
};

export const schedule = async ({
  repository_name,
  custom_fields,
  processUid,
  quantity,
  subProcessUid,
  group,
}: ExecutionsType.ExecutionsParamsAPI): Promise<ExecutionsType.ExecutionsResponseAPI | null> => {
  try {
    const { data } = await Request.post('/executions/schedule', {
      repository_name,
      process_name: processUid,
      sub_process_name: subProcessUid,
      qtd_massa: quantity,
      custom_fields,
      group,
    });

    return data;
  } catch (error) {
    return null;
  }
};

export const listAll = async (): Promise<
  ExecutionsType.ExecutionsResponseAPI[]
> => {
  try {
    const { data } = await Request.get(`/executions`);
    return data;
  } catch (error) {
    return [];
  }
};

export const consumeTestData = async ( qtd_data: number, id_test_data: string): Promise<void> => {
  try {
    await Request.post(`/test_data/consume_data`, {
      "qtd_data": qtd_data,
      "id_test_data": id_test_data,
    });
  } catch (error) {
    console.error('Erro ao consumir a massa de dados:', error);
  }
}

export const download = async (id: string): Promise<void> => {
  try {

    const { data } = await Request.get(`/executions/download/${id}`, {
      responseType: 'json', // Trata a resposta como JSON
    });
    fileDownload(JSON.stringify(data, null, 2), `${id}.json`);
  } catch (error) {
    console.error('Erro ao baixar o arquivo:', error);
  }
};
export const listAllTestData = async (): Promise<ExecutionsType.TestDataResponseAPI[]> => {
  try {
    const { data } = await Request.get('/test_data');
    return data;
  } catch (error) {
    return [];
  }
};